















import Vue from "vue";
import Card from "@/components/atoms/Card/index.vue";

export default Vue.extend({
  components: { Card },
  props: {
    title: {
      type: String,
      default: "お知らせ",
    },
    infoList: {
      type: Array,
    },
  },
});
